import { render } from "./modal-diskon.vue?vue&type=template&id=6251def3&scoped=true&ts=true"
import script from "./modal-diskon.vue?vue&type=script&lang=ts"
export * from "./modal-diskon.vue?vue&type=script&lang=ts"

import "./modal-diskon.vue?vue&type=style&index=0&id=6251def3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6251def3"]])

export default __exports__